<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <main-toolbar></main-toolbar>
      <!--
        <v-layout wrap justify-start algin-center class="hidden-lg-and-up">
         mobile Ansicht scannen
           <v-flex xs6 sm6 md4 @click="startScan()">
            <v-card class="ma-2">
              <v-img src="static/Titel_Surfandscan_scannen.png">
              </v-img>
              <v-card-text
                class="headline font-weight-light textblue"
              >
                scannen
              </v-card-text>
            </v-card>
          </v-flex>
         Ende mobile Ansicht scannen
         mobile Ansicht finden
          <v-flex xs6 sm6 md4 @click="searchDocument()">
            <v-card class="ma-2 bgsas">
              <v-img src="static/Titel_Surfandscan_finden.png">
              </v-img>
              <v-card-text
                class="headline font-weight-light textblue"
              >
                finden
              </v-card-text>
            </v-card>
          </v-flex>
         Ende mobile Ansicht finden
         mobile Ansicht hochladen

           Start Dialog zum Hochladen
           Start Hochladen von Daten
             Start Ansicht Browser hochladen
            <v-flex xs6 sm6 md4 @click.stop="dialog = true" class="handpointer">
              <v-card class="ma-2 bgsas">
                <v-img src="static/Titel_Surfandscan_hochladen.png">
                </v-img>
                <v-card-text
                  class="headline font-weight-light textblue"
                >
                  hochladen
                </v-card-text>
              </v-card>
            </v-flex>
             Ende Ansicht Browser hochladen
           Ende Hochladen von Daten

          <v-dialog
            v-model="dialog"
            max-width="500"
          >
            <v-card>
              <v-card-title class="headline font-weight-light textblue">Eigene PDF Dateien hochladen</v-card-title>
              <v-layout justify-center class="borderStyleUpload ma-4">
                <v-flex xs6 sm6 md6>
                  <v-img src="static/Titel_Surfandscan_Upload_Icon.png">
                  </v-img>
                  <v-card-text>
                    Ganz einfach hier Ihre PDF-Datei hinziehen und fertig
                  </v-card-text>
                </v-flex>
              </v-layout>
              <v-card-text class="text-left">
                <span class="font-weight-bold textblue body-2 ">Tipp:</span> <br>
                Sie können immer PDF-Dateien hochladen,<br> wenn Sie die PDF-Datei in <span style="color:#3271b3">surf</span><span style="color:#71cbf4">and</span><span style="color:#3271b3">scan</span> ziehen.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="blue"
                  flat="flat"
                  @click="dialog = false"
                >
                  Abbrechen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
           Ende Dialog zum Hochladen
         Ende mobile Ansicht hochladen
        </v-layout>-->
      <!-- --------------------------  Browser Ansicht  -------------------------------------------- -->
      <v-card flat color="transparent" class="mt-5">
          <v-layout row wrap justify-space-around fill-height align-center class="hidden-md-and-down">
          <v-flex xs12 sm12 md4 lg4 @click="startScan()" class="handpointer">

            <v-hover class="hidden-md-and-down">
            <v-card color="white" height="332" class="ma-4" slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`">
              <v-layout justify-center>
                <v-flex xs12 sm12 md12 class="">
                  <v-img src="static/Titel_Surfandscan_scannen.png">
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out blau v-card--reveal display-3 white--text"
                        style="height: 100%;"
                      >
                        Jetzt scannen
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-card>
            </v-hover>

          </v-flex>

          </v-layout>
        </v-card>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card @click="manuellUpload">
        <v-card-title class="headline font-weight-light textgrey">Eigene PDF Dateien hochladen
        <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon color="grey">clear</v-icon></v-btn>
        </v-card-title>
        <v-layout justify-center class="borderStyleUpload ma-4 upluadimg">
          <v-flex xs6 sm6 md6>
            <v-img src="static/Titel_Surfandscan_Upload_Icon.png">
            </v-img>
            <v-card-text>
              Ganz einfach hier Ihre PDF-Datei hinziehen und fertig
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-card-text class="text-left">
          <span class="font-weight-bold textgrey body-2 ">Tipp:</span> <br>
          Sie können immer PDF-Dateien hochladen,<br> wenn Sie die PDF-Datei in <span style="color: #6f6f6e;font-weight: 400">surf</span><span
          style="color: #6f6f6e;font-weight: bolder">and</span><span
          style="color: #6f6f6e;font-weight: 400">scan</span> ziehen.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            class="text-none"
            flat="flat"
            @click="dialog = false"
          >
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <main-footer></main-footer>
  </v-container>
</template>

<script>
import Vue from 'vue'
import mainFooter from './footer/MainFooter'
import MainToolbar from './toolbar/MainToolbar'
import MPage1 from './pages/Page02'
import sas from 'surfandscan'
import Vorteilepremium from './widgets/Vorteilepremium'
export default {
  name: 'Main',
  components: {MPage1, MainToolbar, mainFooter, Vorteilepremium},
  data () {
    return {
      pageCnt: 10,
      currentPage: 1,
      dialog: false,
      sasConfig: null,
      isLoading: false,
      interval: {},
      scanParameter: {
        isDuplex: false,
        feederUnit: 0
      },
      value: 0
    }
  },
  mounted () {
    this.sasConfig = Vue.prototype.$sasConfig
    Vue.prototype.scanApi.updateUrl(sas)
  },
  methods: {
    manuellUpload () {
      console.log('manuellUpload')
      this.$eventHub.$emit('OnManuellUpload', false)
    },
    startScan () {
      console.log('startScan')
      Vue.prototype.scanApi.setCurrentJob(null)
      this.$router.push('page4')
    },
    searchDocument () {
      console.log('Search')
      this.$router.push('Search')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue